import { useMemo } from 'react';
import type { CleaningCompletionReportApartment } from '@/shared/api';
import { EChart } from '@/shared/charts/EChart';
import {
  completionChartHeight,
  completionChartOption,
  completionChartSentence,
} from './completionChart';

/**
 * Diagramm der Auswertung: Reinigungen je Apartment und davon mit vollständigem Fotonachweis. Die
 * Tabelle darunter ist die Alternative mit allen Werten; der Satz fasst für Vorleser zusammen.
 */
export function CompletionReportChart({
  apartments,
  onSelectApartment,
}: {
  apartments: CleaningCompletionReportApartment[];
  onSelectApartment: (propertyId: string) => void;
}) {
  const option = useMemo(() => completionChartOption(apartments), [apartments]);
  const sentence = completionChartSentence(apartments);
  return (
    <section
      aria-labelledby="completion-chart-title"
      className="border-hairline rounded-tile flex flex-col gap-2 border bg-white p-4"
    >
      <h2 id="completion-chart-title" className="font-serif text-lg font-bold">
        Reinigungen je Apartment
      </h2>
      <p className="text-ink-soft text-sm">{sentence}</p>
      <div style={{ height: completionChartHeight(apartments.length) }}>
        <EChart
          option={option}
          ariaLabel={`Reinigungen je Apartment. ${sentence}`}
          className="h-full min-h-0"
          onClick={(params) => {
            const id = (params as { data?: { id?: string } }).data?.id;
            if (id) onSelectApartment(id);
          }}
        />
      </div>
    </section>
  );
}
